"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFiatPrice = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const Interfaces_1 = require("../Interfaces");
const QuotationSocketMgr_1 = require("../QuotationSocketMgr");
const STABLE_COIN = ["USDT", "USDC", "USDP", "BUSD"];
function useFiatPrice(coin, symbolMap, isActive = true) {
    const [fiatPrice, setFiatPrice] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!isActive || !coin || !symbolMap) {
            return;
        }
        if (STABLE_COIN.includes(coin)) {
            setFiatPrice(1);
            return;
        }
        let symbol = symbolMap.get(`${coin}/USDT`);
        if (!symbol) {
            symbol = symbolMap.get(`${coin}/BTC`);
        }
        if (!symbol) {
            symbol = symbolMap.get(`${coin}/ETH`);
        }
        if (!symbol) {
            symbol = [...symbolMap.values()].find((item) => item.base === coin);
        }
        if (symbol) {
            // 有可交易的币对
            setFiatPrice(undefined);
            const subscription = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)()
                .getTickerWebSocket()
                .getTickerObservableByPair(Interfaces_1.EXCHANGE_PIONEXV2, coin, "USDT")
                .pipe((0, operators_1.take)(1))
                .subscribe({
                next: (data) => {
                    setFiatPrice(data.fiat);
                },
                error: () => { },
            });
            return () => subscription.unsubscribe();
        }
        else {
            setFiatPrice(null);
        }
    }, [coin, isActive, symbolMap]);
    return fiatPrice;
}
exports.useFiatPrice = useFiatPrice;
